module.exports = __webpack_public_path__ + "static/media/visa-selected.787ee9b9.svg";